import React from "react";
import "./index.css";
import ChatbotMakerForm from "./ChatbotMakerForm";

class EditChatbotModal extends React.Component {
  chatbotForm = null;
  state = {
    publishBtnDisable: true,
    chatbot: null,
  };

  render() {
    const { chatbot } = this.props;

    return (
      <div
        className="modal fade"
        id="edit_chatbot_form_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit {chatbot && chatbot.name}</h5>
              <div>
                <button
                  type="button"
                  className="btn delete-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.props.deleteChatbot}
                >
                  <span>Delete</span>
                </button>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="chatbot-maker-content">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: -10,
                  }}
                >
                  {chatbot && (
                    <ChatbotMakerForm
                      ref={(ref) => (this.chatbotForm = ref)}
                      initial={chatbot}
                      publishChatbot={this.props.updateChatbot}
                      onUpdateStatus={(chatbot) => {
                        this.setState({
                          chatbot,
                          publishBtnDisable:
                            !chatbot.name ||
                            !chatbot.icon ||
                            !chatbot.welcomeText ||
                            chatbot.toc === undefined ||
                            (chatbot.toc && !chatbot.tocText) ||
                            chatbot.communicationLayers.some(
                              (obj) => !obj.type || !obj.statement
                            ),
                        });
                      }}
                    />
                  )}
                  {this.state.chatbot &&
                    this.state.chatbot.name &&
                    this.state.chatbot.icon &&
                    this.state.chatbot.welcomeText &&
                    this.state.chatbot.toc !== undefined && (
                      <div className="chatbot-publish-options">
                        <button
                          className={`btn warning-button`}
                          type="button"
                          onClick={() =>
                            this.chatbotForm
                              ? this.chatbotForm.addNewCommunicationLayer()
                              : null
                          }
                        >
                          Add new communication layer
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() =>
                  this.chatbotForm ? this.chatbotForm.publishChatbot() : null
                }
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditChatbotModal;



// WEBPACK FOOTER //
// ./src/screens/ChatbotMaker/EditChatbotModal.js